import { InLocalStorage } from "../../common/InLocalStorage";
import DatesHelper from "../../common/datesHelper";
import Period from "../../common/period";

export interface IExpirationFilter {
    period: Period;
    onContract: boolean | null;
    mapMode: boolean;
    showPrevYears: boolean;
    scheduledExpirations: boolean | null;
}

export class ExpirationFilterStore {
    private _storage = new InLocalStorage<IExpirationFilter | null>("ExpirationFilter");

    constructor() {
        if (!this._storage.get())
            this.clear();
    }

    get(): IExpirationFilter {
        var stored = this._storage.get();
        if (!stored) {
            const today = DatesHelper.Today();
            return {
                period: Period.Create(DatesHelper.AddDays(today, -30), today),
                onContract: null,
                mapMode: false,
                showPrevYears: false,
                scheduledExpirations: null,
            };
        }

        return stored;
    }

    set(period: Period, onContract: boolean | null, mapMode: boolean, showPrevYears: boolean, scheduledExpirations: boolean | null) {
        this._storage.set({
            period,
            onContract,
            mapMode,
            showPrevYears,
            scheduledExpirations
        });
    }

    clear() {
        this._storage.set(null);
    }
}

export default new ExpirationFilterStore();